import axios from "axios";
import { useNavigate } from "react-router-dom";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
//   baseURL: "http://localhost:3001/",
  headers: {
    "Content-Type": "application/json",
  },
});

// Request Interceptor: Attach token to every request
apiClient.interceptors.request.use(
  async (config) => {
    try {
      const userId = localStorage.getItem("mcp_user_id");
      const token = localStorage.getItem("mcp_token");

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      if (userId) {
        config.headers["user_id"] = userId;
      }
    } catch (error) {
      console.log("Error in request interceptor:", error);
    }

    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const navigate = useNavigate();
      localStorage.removeItem("mcp_user_id");
      localStorage.removeItem("mcp_token");
      navigate("/signin");
    }
    return Promise.reject(error);
  }
);

export default apiClient;
